import { ServiceCatalogItem } from "../../store/ServiceCatalog/types";
import { TariffWithPricesViewType } from "../../store/Catalogs/types";
import { ExtendedArticleEntityType } from "../../store/Jobs/types";
import { TemplateWithItems } from "../../store/Templates/templates.store";

export interface ItemDisplayInfo {
	type: "tariff" | "article" | "template";
	badge: string;
	badgeClass: string;
	code: string;
	description: string;
	id: string | number;
}

export function getItemDisplayInfo(
	item: ServiceCatalogItem,
	tariffsLookup: Record<string, Record<string, TariffWithPricesViewType>>,
	articles: Record<string, Record<string, ExtendedArticleEntityType>>,
	templatesLookup: Record<number, TemplateWithItems>
): ItemDisplayInfo | null {
	if (item.tariffs_default_id || item.tariffs_custom_id) {
		const tariffId = item.tariffs_custom_id || item.tariffs_default_id;
		for (const codeEntries of Object.values(tariffsLookup)) {
			const tariff = tariffId ? codeEntries[tariffId] : undefined;
			if (tariff) {
				return {
					type: "tariff",
					badge: "T",
					badgeClass: "bg-blue-100 text-blue-700",
					code: tariff.code_e || "",
					description: tariff.description_de || "",
					id: tariff.id!,
				};
			}
		}
		return null;
	}

	if (item.article_id) {
		for (const codeEntries of Object.values(articles)) {
			const article = codeEntries[String(item.article_id)];
			if (article) {
				return {
					type: "article",
					badge: "A",
					badgeClass: "bg-green-100 text-green-700",
					code: article.code_e || "",
					description: article.description_de || "",
					id: article.id,
				};
			}
		}
		return null;
	}

	if (item.template_id) {
		const template = templatesLookup[item.template_id];
		if (template) {
			return {
				type: "template",
				badge: "V",
				badgeClass: "bg-purple-100 text-purple-700",
				code: template.code || "",
				description: template.name || "",
				id: template.id,
			};
		}
		return null;
	}

	return null;
}

export function buildCatalogItemFromTariff(
	tariff: TariffWithPricesViewType
): ServiceCatalogItem {
	if (tariff.organization_id) {
		return { tariffs_custom_id: tariff.id! };
	}
	return { tariffs_default_id: tariff.id! };
}

export function buildCatalogItemFromArticle(
	article: ExtendedArticleEntityType
): ServiceCatalogItem {
	return { article_id: article.id };
}

export function buildCatalogItemFromTemplate(template: {
	id: number;
}): ServiceCatalogItem {
	return { template_id: template.id };
}
